import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UserAccountService } from 'src/app/services/api/user-account.service';
import { UserService } from 'src/app/services/user.service';
import { phoneNumberValidator } from 'src/app/directives/patient-validator.directive';
import { ErrorService } from 'src/app/services/error.service';
import { Router } from '@angular/router';
import { CiviliteService } from 'src/app/services/api/civilite.service';
import { Civilite } from 'src/app/interfaces/civilite';
import { Responsable } from 'src/app/interfaces/responsable';

@Component({
  selector: 'app-settings-user',
  templateUrl: './settings-user.component.html',
  styleUrls: ['./settings-user.component.scss']
})
export class SettingsUserComponent implements OnInit {

    public errorMessage: string = '' ;
    public errorType: string = '';

    civiliteTab: Civilite[] = [];
    public userForm: FormGroup | undefined;

    public responsable: Responsable | undefined;
    
    constructor(public userService: UserService,
                private errorService: ErrorService,
                public route: Router,
                private civiliteService: CiviliteService,
                private userAccountService: UserAccountService) {}

    ngOnInit(): void {
        
        this.civiliteService.getCivilite().subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.civiliteTab = res.content;
            } else {
                this.errorService.errorType = res.result;
                this.errorService.errorMessage = res.content;
                this.route.navigate(['/error']);
            }
        }, (resError) => {
            this.errorService.errorType = "ERROR";
            this.errorService.errorMessage = resError.error.detail;
            this.route.navigate(['/error']);
        });

        this.userAccountService.getUserInformations(this.userService.currentUser.symfonyUser.id).subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.userForm = new FormGroup({
                    lname: new FormControl(res.content.lname),
                    fname: new FormControl(res.content.fname),
                    phoneNumber: new FormControl(res.content.phoneNumber, [phoneNumberValidator()]),
                    civilite: new FormControl(res.content.civilite)
                });

                if (res.content.responsable) {
                    this.responsable = res.content.responsable;
                }

            } else {
                this.errorService.errorType = res.result;
                this.errorService.errorMessage = res.content;
                this.route.navigate(['/error']);
            }
        }, (resError) => {
            this.errorService.errorType = "ERROR";
            this.errorService.errorMessage = resError.error.detail;
            this.route.navigate(['/error']);
        });
        
    }

    askChangePassword() {
        this.userAccountService.resetPassword(this.userService.currentUser.keycloakUser.tokenParsed.sub).subscribe((res) => {
            this.errorType = res.result;
            this.errorMessage = res.content;
        });
    }

    async updateUserInformations(userFormValue: any)
    {
        userFormValue.keycloak_id = this.userService.currentUser.keycloakUser.tokenParsed.sub;
        this.userAccountService.updateUserInformation(userFormValue).subscribe(async (res) => {
            this.errorType = res.result;
            this.errorMessage = res.content;
        });
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.userForm?.controls[controlName].hasError(errorName);
    }
}
